import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { NavLink, withRouter } from 'react-router-dom';
import APIcon from '@alphapoint/apex-web/lib/components/common/APIcon';

class PageHeaderNavMenuComponent extends React.Component {
  submenuNavItemsInitialState = {
    Trade: false,
    // Yield: false,
    Wallet: false,
  };

  state = {
    ...this.submenuNavItemsInitialState,
    activeSubmenu: null,
  };

  componentDidMount() {
    this.setActiveSubmenu();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.setActiveSubmenu();
    }
  }

  setActiveSubmenu = () => {
    const { navItems, location } = this.props;
    let activeSubmenu = null;

    navItems.forEach((item) => {
      if (item.submenuNavItems) {
        item.submenuNavItems.forEach((submenuItem) => {
          if (location.pathname === submenuItem.path) {
            activeSubmenu = item.text;
          }
        });
      }
    });

    this.setState({ activeSubmenu });
  };

  handleNavItemClick = (navItemText) => {
    const isSubmenuNavItem = this.submenuNavItemsInitialState[navItemText] !== undefined;

    this.props.handleNavMenuClick(isSubmenuNavItem);

    this.setState((prevState) => ({
      ...this.submenuNavItemsInitialState,
      [navItemText]: !prevState[navItemText],
      activeSubmenu: isSubmenuNavItem ? navItemText : null,
    }));
  };

  render() {
    const { t } = this.props;

    const { navItems, customClass } = this.props;

    return navItems.map((item) => {
      const isActiveSubmenu = this.state.activeSubmenu === item.text;

      return (
        <div
          key={item.text}
          className={customClass(`nav-item ${item.submenuNavItems ? 'sub-menu' : ''}`, [
            'hoverable',
            `${this.state[item.text] || isActiveSubmenu ? 'opened' : ''}`,
          ])}>
          <NavLink
            to={item.path}
            onClick={() => this.handleNavItemClick(item.text)}
            isActive={(match) => match && item.path !== '#'}
            className={customClass('item')}
            activeClassName={customClass('item', ['selected'])}>
            <span className={customClass(`label ${item.submenuNavItems ? 'submenu-label' : ''}`)}>{t(item.text)}</span>
          </NavLink>
          {item.submenuNavItems && (
            <div className={customClass('sub-menu-item')}>
              <div className="bg-nav-item" />
              <div className={customClass('sub-menu-body')}>
                <ul className={customClass('sub-menu-nav-list')}>
                  {item.submenuNavItems.map((submenuItem) => (
                    <li key={submenuItem.path} className={customClass('sub-menu-nav-list-item')}>
                      <NavLink
                        to={submenuItem.path}
                        onClick={() => this.handleNavItemClick(submenuItem.text)}
                        isActive={(match) => match && match.isExact && match.url === submenuItem.path}
                        className={customClass('item', ['sub-menu', 'hoverable'])}
                        activeClassName={customClass('item', ['selected'])}>
                        <APIcon name={submenuItem.icon} customClass={customClass('icon')} />
                        <div className={customClass('label-wrapper')}>
                          <span className={customClass('label')}>{t(submenuItem.text)}</span>
                          <span className={customClass('subtitle')}>{t(submenuItem.subtitle)}</span>
                        </div>
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </div>
      );
    });
  }
}

PageHeaderNavMenuComponent.propTypes = {
  customClass: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  items: PropTypes.array,
};

export default withTranslation()(withRouter(PageHeaderNavMenuComponent));
